import "./style.scss";

const Textarea = (props) => {
  return <textarea {...props} className="textarea" />;
};

export default Textarea;
